import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Alert,
  Typography,
  IconButton,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import axios from "axios";

const SubirFotoPopup = ({ open, onClose }) => {
  const [foto, setFoto] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  const handleUpload = async () => {
    if (!foto) return;
    const formData = new FormData();
    formData.append("foto", foto);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cambios/subir-foto`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setMensaje({ tipo: "success", texto: "Foto enviada a revisión" });
    } catch (error) {
      console.error("Error al subir la foto:", error);
      setMensaje({ tipo: "error", texto: "No se pudo subir la foto." });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Subir Foto de Perfil</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Button
            variant="outlined"
            component="label"
            startIcon={<PhotoCamera />}
          >
            Seleccionar Foto
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => setFoto(e.target.files[0])}
            />
          </Button>
          {foto && <Typography>{foto.name}</Typography>}
          {mensaje && (
            <Alert severity={mensaje.tipo}>{mensaje.texto}</Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleUpload} variant="contained" disabled={!foto}>
          Subir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubirFotoPopup;